export const NPS_SCALE_SIZE = 11;

export enum NPSAreasEnum {
  Promoters = 'Promoters',
  Passives = 'Passives',
  Detractors = 'Detractors'
}
